// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_jd-0";
export var fileCarousel = "_jd-2";
export var removeFileButton = "_jd-1";